export default {
  add_items: 'Tilføj varer',
  remove_items: 'Fjern varer',
  place_order: 'Afgiv ordre',
  pay_now: 'Betal nu · {{amount}}',
  go_to_menu: 'Gå til menu',
  secure_checkout: 'Sikker betaling...',

  error_messages: {
    payment_unsuccessful: {
      title: 'Betalingen mislykkedes',
      description: 'Tjek dine betalingsoplysninger, og prøv igen.',
    },
    internal_error: {
      title: 'Ordren mislykkedes 😔',
      description:
        'Der opstod desværre et uventet problem med din ordre. Vores tekniske team arbejder allerede på det 🛠️.',
    },
    order_blocked: {
      title: 'Ordre blokeret',
      description:
        'Vi har opdaget mistænkelig aktivitet fra din konto og har blokeret nye ordrer indtil {{datetime}}. Kontakt support på {{supportEmail}} for flere oplysninger.',
      description_no_datetime:
        'Vi har opdaget mistænkelig aktivitet fra din konto og har blokeret nye ordrer. Kontakt support på {{supportEmail}} for flere oplysninger.',
    },
  },

  toasts: {
    input_errors_found: 'Der er nogle problemer med dine ordreoplysninger',
    select_payment_method: 'Vælg en betalingsmetode for at afgive din bestilling.',
  },
};
